import React from "react";
import { useParams, Link } from "react-router-dom";

const PROJECTS = {
  "pro-go": {
    title: "Pro Go",
    description: "A full-stack app for service provider",
    tech: ["Flutter", "Firebase", "Dart"],
    // Use mp4 as animated logo and show screenshots gallery
    logoVideo: "assets/progo/Untitled design.mp4",
    screenshots: [
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.19 AM.jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM.jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (1).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (2).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (3).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (4).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (5).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (6).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (7).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (8).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (9).jpeg",
      "assets/progo/WhatsApp Image 2025-08-18 at 3.50.20 AM (10).jpeg",
    ],
    github: "https://github.com/hassan689",
    figma: "https://www.figma.com",
  },
  "voting-management-system": {
    title: "Voting Management System",
    description: "A full-stack web portal for voting management",
    tech: ["React", "Node.js", "Express", "Mysql"],
    image: null,
    // Do not include cover icon in gallery; only real screenshots
    screenshots: [
      "assets/voting/schema.png",
      "assets/voting/Screenshot (20).png",
      "assets/voting/Screenshot (21).png",
      "assets/voting/Screenshot (22).png",
      "assets/voting/Screenshot (23).png",
      "assets/voting/Screenshot (24).png",
      "assets/voting/Screenshot (27).png",
      "assets/voting/Screenshot (28).png",
    ],
    masonry: true,
    github: "https://github.com/hassan689",
    figma: "https://www.figma.com",
    video: null,
  },
  "foody-fast": {
    title: "Foody-Fast",
    description: "Foody-Fast app for my university friends",
    tech: ["Flutter", "Firebase", "Stripe"],
    image: null,
    github: "https://github.com/hassan689/Foodyfast.git",
    figma: "https://www.figma.com/design/EbL9mhMGnyhNoUo7eqOcfm/Untitled?node-id=0-1&t=kqEZoqX7OWQFYiSr-1",
    screenshots: [
      "assets/foodyfast/Logo.png",
      "assets/foodyfast/home.png",
      "assets/foodyfast/menu.png",
      "assets/foodyfast/cart.png",
    ],
    masonry: false,
    video: null,
  },
  "ping-pong": {
    title: "Ping Pong",
    description: "Ping pong game using hand gestures",
    tech: ["Python", "Opencv"],
    image: `${process.env.PUBLIC_URL}/logo512.png`,
    github: "https://github.com/hassan689",
    figma: "https://www.figma.com",
    video: null,
  },
};

const ProjectDetail = () => {
  const { slug } = useParams();
  const project = PROJECTS[slug];

  if (!project) {
    return (
      <div style={{ padding: "4rem 1.5rem", color: "#fff" }}>
        <h2>Project not found</h2>
        <Link to="/portfolio" style={{ color: "#fff", textDecoration: "underline" }}>Back to projects</Link>
      </div>
    );
  }

  const toPublicUrl = (path) => {
    const base = process.env.PUBLIC_URL || "";
    const normalized = `${base}${path.startsWith('/') ? '' : '/'}${path}`;
    // Encode each segment to handle spaces, parentheses, etc., without breaking slashes
    const encoded = normalized
      .split('/')
      .map((seg, idx) => (idx === 0 && seg === '' ? '' : encodeURIComponent(seg)))
      .join('/');
    return encoded;
  };

  const isProGo = slug === "pro-go";
  const isVoting = slug === "voting-management-system";
  const isFoody = slug === "foody-fast";
  const isPingPong = slug === "ping-pong";
  const hasSidebar = isProGo || isVoting || isFoody || isPingPong;

  return (
    <div style={{ padding: "4rem 1.5rem", color: "#fff" }}>
      <Link to="/portfolio" style={{ color: "#fff", textDecoration: "underline" }}>&larr; Back</Link>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: hasSidebar ? "repeat(auto-fit, minmax(320px, 1fr))" : "1fr",
          gap: 24,
          alignItems: "start",
          marginTop: "1rem",
        }}
      >
        {/* Main content */}
        <div>
          <h1 style={{ marginBottom: 8 }}>{project.title}</h1>
          <p style={{ opacity: 0.9, marginBottom: 12 }}>{project.description}</p>

          {/* Media block: prefer animated logo video for Pro Go */}
          {project.logoVideo ? (
            <video
              src={toPublicUrl(project.logoVideo)}
              autoPlay
              loop
              muted
              playsInline
              style={{ width: "100%", maxWidth: 480, borderRadius: 16, margin: "1rem 0" }}
            />
          ) : (
            project.image && (
              <img
                src={project.image}
                alt={`${project.title} cover`}
                style={{ width: "100%", maxWidth: 960, borderRadius: 16, margin: "1rem 0" }}
              />
            )
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(120px, max-content))",
              gap: 8,
              alignItems: "start",
              justifyContent: "start",
              margin: "1rem 0",
            }}
          >
            {project.tech.map((t) => (
              <span key={t} style={{ padding: "6px 10px", border: "1px solid rgba(255,255,255,0.2)", borderRadius: 999, whiteSpace: "nowrap" }}>{t}</span>
            ))}
          </div>

          {/* Screenshots gallery */}
          {Array.isArray(project.screenshots) && project.screenshots.length > 0 && (
            project.masonry ? (
              // Masonry-like layout using CSS columns to preserve natural heights
              <div style={{
                columnCount: 1,
                columnGap: 12,
                marginTop: 16,
              }}>
                <div style={{
                  columnCount: 1,
                  columnGap: 12,
                }}
                className="masonry-container"
                >
                  {project.screenshots.map((shot) => (
                    <img
                      key={shot}
                      src={toPublicUrl(shot)}
                      alt={`${project.title} screenshot`}
                      loading="lazy"
                      style={{
                        width: "100%",
                        height: "auto",
                        breakInside: "avoid",
                        WebkitColumnBreakInside: "avoid",
                        borderRadius: 12,
                        background: "#111",
                        marginBottom: 12,
                      }}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                gap: 12,
                marginTop: 16,
              }}>
                {project.screenshots.map((shot) => (
                  <img
                    key={shot}
                    src={toPublicUrl(shot)}
                    alt={`${project.title} screenshot`}
                    loading="lazy"
                    style={{ width: "100%", height: "auto", borderRadius: 12, background: "#111" }}
                  />
                ))}
              </div>
            )
          )}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(140px, max-content))",
              gap: 12,
              alignItems: "start",
              justifyContent: "start",
              marginTop: 16,
            }}
          >
            {project.github && <a href={project.github} target="_blank" rel="noreferrer" style={{ color: "#000", background: "#fff", padding: "10px 14px", borderRadius: 999, textDecoration: "none", fontWeight: 600, textAlign: "center" }}>GitHub</a>}
            {project.figma && <a href={project.figma} target="_blank" rel="noreferrer" style={{ color: "#000", background: "#fff", padding: "10px 14px", borderRadius: 999, textDecoration: "none", fontWeight: 600, textAlign: "center" }}>Figma</a>}
            {project.video && <a href={project.video} target="_blank" rel="noreferrer" style={{ color: "#000", background: "#fff", padding: "10px 14px", borderRadius: 999, textDecoration: "none", fontWeight: 600, textAlign: "center" }}>Video</a>}
          </div>
        </div>

        {/* Right-hand sidebar for Pro Go */}
        {isProGo && (
          <aside
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16,
              padding: 16,
            }}
          >
            <h3 style={{ marginTop: 0 }}>ProGo</h3>
            <p style={{ opacity: 0.9 }}>
              ProGo is a modern, location‑aware marketplace built with Flutter that connects service
              providers with people who need help. Users can post clearly scoped jobs with budgets and
              deadlines, browse and filter nearby tasks on an interactive map, review provider/client
              profiles with ratings, and chat in real time to align on details before accepting work.
              Secure, integrated payments streamline checkout, while transparent reviews and profiles
              build trust on both sides of the marketplace.
            </p>
            <p style={{ opacity: 0.9, marginTop: 8 }}>
              Under the hood, ProGo uses Firebase Auth, Cloud Firestore, and Storage for secure accounts,
              real‑time data, and media uploads; FCM for push notifications; Google Maps for geospatial
              search and routing; and end‑to‑end payment flows to ensure safe transactions. The app
              supports offline‑friendly reads, optimistic updates, and role‑based access (poster vs provider),
              and it scales across Android, iOS, and Web with consistent UI performance and accessibility.
            </p>
          </aside>
        )}

        {/* Right-hand sidebar for Voting Management System */}
        {isVoting && (
          <aside
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16,
              padding: 16,
            }}
          >
            <h3 style={{ marginTop: 0 }}>Voting Management System</h3>
            <p style={{ opacity: 0.9 }}>
              A secure, role‑based web portal that digitizes end‑to‑end elections: administrators set up
              constituencies, parties, and ballots; returning officers manage candidate nominations and
              scheduling; voters register, verify their identity, and cast secret ballots from responsive
              interfaces. Real‑time turnout stats, results dashboards, and immutable audit trails improve
              transparency and speed over manual processes.
            </p>
            <p style={{ opacity: 0.9, marginTop: 8 }}>
              The stack includes a React frontend, a Node/Express API, and a relational database for strong
              consistency (MySQL/PostgreSQL). Security features span JWT sessions, password hashing,
              CSRF protection, request validation, rate limiting, and strict authorization checks per role.
              The system supports election phases, data export, and accessibility‑focused UI for broad
              participation across devices.
            </p>
          </aside>
        )}

        {/* Right-hand sidebar for Foody‑Fast */}
        {isFoody && (
          <aside
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16,
              padding: 16,
            }}
          >
            <h3 style={{ marginTop: 0 }}>Foody‑Fast</h3>
            <p style={{ opacity: 0.9 }}>
              A fast, cross‑platform Flutter food ordering app with rich menus, item customization,
              smart search, favorites, and a streamlined cart‑to‑checkout flow. Users can track orders in
              real time, receive deal notifications, and enjoy a responsive, polished UI designed for
              smooth interactions on mobile and web.
            </p>
            <p style={{ opacity: 0.9, marginTop: 8 }}>
              Powered by Firebase (Auth, Firestore, Storage, FCM) for real‑time data and messaging,
              integrated payments (e.g., Stripe/JazzCash), and Google Maps for delivery context and ETAs.
              The app emphasizes accessibility, performance, and scalable data models to handle growing
              catalogs and order volumes with predictable latency.
            </p>
          </aside>
        )}

        {/* Right-hand sidebar for Ping Pong */}
        {isPingPong && (
          <aside
            style={{
              background: "rgba(255,255,255,0.04)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: 16,
              padding: 16,
            }}
          >
            <h3 style={{ marginTop: 0 }}>Ping Pong (Gesture‑Controlled)</h3>
            <p style={{ opacity: 0.9 }}>
              A computer‑vision game where you control the paddle with hand gestures. The experience blends
              lightweight physics with webcam input for intuitive, controller‑free play, supporting quick
              calibration and responsive tracking for a fun arcade feel.
            </p>
            <p style={{ opacity: 0.9, marginTop: 8 }}>
              Built with Python and OpenCV/MediaPipe pipelines for detection and tracking, plus a minimal
              rendering layer for smooth motion at typical webcam frame rates. Includes scoring, difficulty
              ramps, and optional overlays to visualize landmarks and hit zones.
            </p>
          </aside>
        )}
      </div>
    </div>
  );
};

export default ProjectDetail;


